var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomFieldDateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 14,
    viewBox: "0 0 50 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161074",
    "data-name": "Group 161074",
    transform: "translate(-2640 -359)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Date",
    transform: "translate(2661 370)",
    fill: "#0d0d0d",
    fontSize: 12,
    fontFamily: "Silka-Regular, Silka"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Date")), /*#__PURE__*/React.createElement("path", {
    id: "date-svgrepo-com",
    d: "M2.6,14.057H13.454a.6.6,0,0,0,.6-.6V4.411a.6.6,0,0,0-.6-.6H11.042V2.6a.6.6,0,0,0-1.206,0V3.808H6.22V2.6a.6.6,0,1,0-1.206,0V3.808H2.6a.6.6,0,0,0-.6.6v9.042A.6.6,0,0,0,2.6,14.057Zm.6-9.042h9.645V6.823H3.206Zm0,3.014h9.645v4.823H3.206Z",
    transform: "translate(2638 357.31)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFieldDateIcon);
export default __webpack_public_path__ + "static/media/custom-field-date-icon.53b099b65d2e5005472af9912a5cca97.svg";
export { ForwardRef as ReactComponent };